export class NativeStreamTransformProbeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "sampleEvents",
            "baseName": "sampleEvents",
            "type": "Array<{ [key: string]: any; }>",
            "format": ""
        },
        {
            "name": "schema",
            "baseName": "schema",
            "type": "NativeStreamSchemaConfig",
            "format": ""
        },
        {
            "name": "transform",
            "baseName": "transform",
            "type": "NativeStreamTransformConfig",
            "format": ""
        },
        {
            "name": "sampling",
            "baseName": "sampling",
            "type": "NativeStreamSamplingConfig",
            "format": ""
        },
        {
            "name": "sourceFileFormat",
            "baseName": "sourceFileFormat",
            "type": "FileFormat",
            "format": ""
        },
        {
            "name": "protectedColumns",
            "baseName": "protectedColumns",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamTransformProbeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
